import Vuex from 'vuex';
const store = new Vuex.Store({
    state: {
        questions:null,
    }
}) 
export default store;